import {
  EMPTY_LIST,
  ENTITY_LISTING_VIEW_TYPE,
} from '../../../../constants/common'
import { ARROW_LEFT_KEY, ARROW_RIGHT_KEY } from '../../../../constants/key'
import { filterVisibleItems } from '../../../../utils/common'
import {
  getListViewTypeWithoutPreview,
  getListViewTypeWithPreview,
  isListViewTypeBoard,
  isListViewTypeWithPreview,
} from '../../../../utils/listViewType'

import {
  TABLE_VIEW_REGIME,
  TABLE_VIEW_REGIME_LABEL_KEY,
} from './TableViewRegimeControl.constants'

import BoardViewIcon from '../../../../icons/board-view.svg'
import PreviewIcon from '../../../../icons/preview.svg'
import TableViewIcon from '../../../../icons/table-view.svg'

function getFocusableOptions(container) {
  return Array.from(container.querySelectorAll('button:not([disabled])'))
}

function getArrowStep(key) {
  return key === ARROW_RIGHT_KEY ? 1 : key === ARROW_LEFT_KEY ? -1 : 0
}

export function getTableViewRegimeNextArrowOption({ container, key, target }) {
  const step = getArrowStep(key)

  const options = step === 0 ? EMPTY_LIST : getFocusableOptions(container)

  return options[options.indexOf(target) + step]
}

// Exactly one option is active: Split while the preview is open, else the body.
export function getTableViewRegimeOptions({
  hasBoard = false,
  hasSplit = true,
  listViewType,
}) {
  const hasPreview = isListViewTypeWithPreview(listViewType)

  const isBoardBody = isListViewTypeBoard(listViewType)

  return filterVisibleItems([
    {
      Icon: TableViewIcon,
      isActive: !isBoardBody && !hasPreview,
      isVisible: true,
      label: TABLE_VIEW_REGIME_LABEL_KEY[TABLE_VIEW_REGIME.table],
      name: TABLE_VIEW_REGIME.table,
      value: ENTITY_LISTING_VIEW_TYPE.table,
    },
    {
      Icon: PreviewIcon,
      isActive: hasPreview,
      isVisible: hasSplit,
      label: TABLE_VIEW_REGIME_LABEL_KEY[TABLE_VIEW_REGIME.split],
      name: TABLE_VIEW_REGIME.split,
      value: hasPreview
        ? getListViewTypeWithoutPreview(listViewType)
        : getListViewTypeWithPreview(listViewType),
    },
    {
      Icon: BoardViewIcon,
      isActive: isBoardBody && !hasPreview,
      isVisible: hasBoard,
      label: TABLE_VIEW_REGIME_LABEL_KEY[TABLE_VIEW_REGIME.board],
      name: TABLE_VIEW_REGIME.board,
      value: ENTITY_LISTING_VIEW_TYPE.board,
    },
  ])
}
